import PropTypes from 'prop-types';
import React from 'react';
import { formatNumberWithCommas } from 'pubweb-smokey/dist/utils/formatters';
import Bed from 'pubweb-smokey/dist/images/svg/iconography-16x16/bed.svg';
import Bath from 'pubweb-smokey/dist/images/svg/iconography-16x16/bath.svg';
import Home from 'pubweb-smokey/dist/images/svg/iconography-16x16/home.svg';
import { HomeSpecsStyles } from './HomeSpecs.styled';

const HomeSpecs = ({ homeDetails }) => {
  return (
    <HomeSpecsStyles>
      <div>
        <Bed className="icon" width="16" height="16" />
        <span className="standard">{homeDetails.beds} beds</span>
      </div>

      <div>
        <Bath className="icon" width="16" height="16" />
        <span className="standard">{homeDetails.baths} baths</span>
      </div>

      <div>
        <Home className="icon" width="16" height="16" />
        <span className="standard">
          {formatNumberWithCommas(homeDetails.maxSquareFeet)} sq. ft.
        </span>
      </div>
    </HomeSpecsStyles>
  );
};

HomeSpecs.propTypes = {
  homeDetails: PropTypes.shape({
    baths: PropTypes.any,
    beds: PropTypes.any,
    maxSquareFeet: PropTypes.any,
  }),
};

export default HomeSpecs;
